/**
 * Wait DOM is ready depending on a state.
 *
 * - `interactive`: Defer scripts are executing, but DOM is ready
 * - `complete`: All scripts including deferred ones are executed and DOM is ready
 *
 * @see https://stackoverflow.com/a/65430734/5506547
 * @see https://stackoverflow.com/a/51980980/5506547
 */
const ready = (fn, state = "complete") => {
  return new Promise(resolve => {
    if (document.readyState === state) {
      fn === null || fn === void 0 ? void 0 : fn();
      resolve();
    } else {
      document.addEventListener("readystatechange", () => {
        if (document.readyState === state) {
          fn === null || fn === void 0 ? void 0 : fn();
          resolve();
        }
      });
    }
  });
};

export { ready };